import { z } from 'zod';

export const DiagramPositionSchema = z
    .object({
        x: z.number().default(0),
        y: z.number().default(0),
    })
    .default({});
